import { UserProfileDropdown } from '@common/UserProfileDropdown';
import { SettingsBIcon } from '@prophecy/ui-v3/Icons';
import { Stack } from '@prophecy/ui-v3/Layout';
import { theme } from '@prophecy/ui-v3/theme';
import { Text } from '@prophecy/ui-v3/Typography';
import styled from 'styled-components';

export const ProfessionalEditionHeader = () => {
  return (
    <ProfessionalEditionHeaderWrapper
      direction='horizontal'
      align='space-between'
      alignY='center'
      gap={theme.spaces.x8}
      width='100%'>
      <Stack direction='horizontal' align='center' gap={theme.spaces.x8}>
        <SettingsBIcon type={'default'} />
        <Text level='sm' weight={theme.fontWeight.medium} tone={theme.colors.gray700}>
          Account Settings
        </Text>
      </Stack>
      <UserProfileDropdown />
    </ProfessionalEditionHeaderWrapper>
  );
};

const ProfessionalEditionHeaderWrapper = styled(Stack)`
  background: ${theme.colors.gray50};
  border: 1px solid ${theme.colors.gray200};
  padding: ${theme.spaces.x6} ${theme.spaces.x12};
  width: 100%;
`;
